import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import AntTable from "../components/CommonTable";
import CommonButton from "../components/CommonButton";
import API from "../api";
import { AxiosResponse } from "axios";
import {
  DatePicker,
  Input,
  InputNumber,
  Select,
  Space,
  Switch,
  TableProps,
  message,
} from "antd";
import style from "../style/twoColForm.module.scss";
import btnStyle from "../style/btn.module.scss";
import { storage } from "../utils/storage";
import SearchFeature from "./SearchFeture";
import { antdMessageError } from "../utils/antdMessageComponent";
import {
  defaultData,
  Data,
  RentCalculationKeys,
  DaySpecificRentCalculation,
} from "../utils/const/partner_bike";
import { AllowInputType, handleNumericInput } from "../utils/ValidationReg";
import dayjs from "dayjs";

function CreateEditBike({
  mode,
  setMode,
  data,
  id,
}: {
  mode: "edit" | "create";
  setMode: Dispatch<SetStateAction<"edit" | "create" | "home">>;
  data: Data;
  id?: string;
}) {
  const [formDataD, setFormDataD] = useState(data);
  const [errors, setErrors] = useState<any>({});
  const [bikeData, setBikeData] = useState(
    [] as { _id: string; name: string }[]
  );

  useEffect(() => {
    (async () => {
      const bikes = await API.partner.GetBikesVariant();
      if (!API.validators.checkSuccessCode(bikes)) return;

      const modifiedBikeData = bikes.data?.data?.map((item: any) => {
        return {
          value: item?._id,
          label: item?.name,
        };
      });

      setBikeData(modifiedBikeData);
    })();
  }, []);

  const validateForm = () => {
    const newErrors: any = {};
    if (!formDataD.name) newErrors.name = "Name is required.";
    if (!formDataD.bikeVariant)
      newErrors.bikeVariant = "Bike Variant name is required.";
    if (!formDataD.mfgYear) newErrors.mfgYear = "mfgYear is required.";
    if (!formDataD.number) newErrors.number = "Transmission type is required.";
    if (formDataD.speedLimit === "" || formDataD.speedLimit == null) newErrors.speedLimit = "speedLimit is required.";
    if (formDataD.timePenalty == null)
      newErrors.timePenalty = "timePenalty is required.";
    if (formDataD.distancePenalty == null)
      newErrors.distancePenalty = "distancePenalty is required.";
    if (formDataD.securityDepositAmount == null)
      newErrors.securityDepositAmount = "securityDepositAmount is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const invalidEntries = Object.keys(formDataD.rentCalculations).filter(
    (key) => {
      const typedKey = key as RentCalculationKeys;
      const rentalPlan = formDataD.rentCalculations[typedKey];

      return (
        !rentalPlan.disabled &&
        (!rentalPlan.price ||
          rentalPlan.price < 1 ||
          !rentalPlan.kmLimit ||
          rentalPlan.kmLimit < 1)
      );
    }
  );

  const onSave = async () => {
    if (!validateForm()) {
      return antdMessageError("Please fill all required fields.");
    }

    if (invalidEntries.length > 0) {
      message.error(
        "Please ensure all enabled rental plans have Price & Km Limit greater than 1."
      );
      return;
    }
    const stationId = storage.getSelectedStation().id;
    if (!stationId) {
      return antdMessageError("Please select a station before saving.");
    }
    // Create a copy of formDataD for API call with station ID
    const { station, ...dataWithoutStation } = formDataD;
    const apiData = { ...dataWithoutStation, station: stationId };
    let createBike;
    if (mode === "create") {
      delete apiData._id;
      createBike = await API.partner.CreateBike(apiData);
    }
    if (mode === "edit")
      createBike = await API.partner.EditBike(
        apiData,
        apiData._id as string
      );

    if (
      API.validators.checkSuccessCode(createBike as AxiosResponse<any, any>)
    ) {
      message.success("Details uploaded successfully");
      setMode("home");
    } else {
      message.error("Technical Error Occured");
    }
  };

  console.log(formDataD);

  return (
    <div>
      <div className={style["container"]}>
        <h1>Add Bike Details</h1>
        <div className={style["wrap-inp"]}>
          <div className={style["inp-container"]}>
            <label htmlFor="name">
              Bike Name<span>*</span>
            </label>
            <Input
              value={formDataD.name}
              onChange={(e) => {
                setFormDataD({
                  ...formDataD,
                  name: AllowInputType(e.target.value, "alphanumeric"),
                });
              }}
              name="name"
              className={errors.name ? style["error-border"] : ""}
            />
          </div>
          <div className={style["inp-container"]}>
            <label htmlFor="bike">
              Bike Modal<span>*</span>
            </label>
            <Select
              value={formDataD.bikeVariant}
              placeholder={"select Bike"}
              onChange={(value) => {
                setFormDataD({ ...formDataD, bikeVariant: value });
              }}
              options={bikeData}
              className={errors.bikeVariant ? style["error-border"] : ""}
              showSearch
              optionFilterProp="label"
            />
          </div>
        </div>
        <div className={style["wrap-inp"]}>
          <div className={style["inp-container"]}>
            <label htmlFor="bikeNumber">
              Bike Number <span>*</span>
            </label>
            <Input
              value={formDataD.number}
              onChange={(e) => {
                setFormDataD({
                  ...formDataD,
                  number: AllowInputType(e.target.value, "alphanumeric"),
                });
              }}
              name="bikeNumber"
              className={errors.number ? style["error-border"] : ""}
            />
          </div>
          <div className={style["inp-container"]}>
            <label htmlFor="manufacturingYear">
              Manufacturing Year<span>*</span> -- {formDataD.mfgYear}
            </label>
            <DatePicker
              value={formDataD.mfgYear && dayjs(formDataD.mfgYear)}
              // defaultValue={new Date().toISOString().split("T")[0]}
              picker={"year"}
              onChange={(date, dateString) => {
                setFormDataD({ ...formDataD, mfgYear: dateString as string });
              }}
              className={errors.mfgYear ? style["error-border"] : ""}
            />
          </div>
        </div>
        <div className={style["wrap-inp"]}>
          <div className={style["inp-container"]}>
            <label htmlFor="speedLimit">
              Speed Limit (km/hr)<span>*</span>
            </label>
            <Input
              value={formDataD.speedLimit}
              onChange={(e) => {
                setFormDataD({
                  ...formDataD,
                  speedLimit: AllowInputType(e.target.value, "numeric"),
                });
              }}
              name="speedLimit"
              className={errors.speedLimit ? style["error-border"] : ""}
            />
          </div>
          <div className={style["inp-container"]}>
            <label htmlFor="timePenalty">
              Time Penalty (per hour)<span>*</span>
            </label>
            <InputNumber
              value={formDataD.timePenalty}
              onChange={(value) => {
                setFormDataD({
                  ...formDataD,
                  timePenalty: Number(
                    AllowInputType(String(value ?? ""), "numeric")
                  ),
                });
              }}
              onKeyDown={handleNumericInput}
              name="timePenalty"
              className={errors.timePenalty ? style["error-border"] : ""}
            />
          </div>
        </div>
        <div className={style["wrap-inp"]}>
          <div className={style["inp-container"]}>
            <label htmlFor="distancePenalty">
              Distance Penalty (per km)<span>*</span>
            </label>
            <InputNumber
              value={formDataD.distancePenalty}
              onChange={(value) => {
                setFormDataD({ ...formDataD, distancePenalty: Number(value) });
              }}
              name="distancePenalty"
              className={errors.distancePenalty ? style["error-border"] : ""}
              onKeyDown={handleNumericInput}
            />
          </div>
          <div className={style["inp-container"]}>
            <label htmlFor="securityAmountDeposit">
              Security Amount Deposit (Rupees)<span>*</span>
            </label>
            <InputNumber
              value={formDataD.securityDepositAmount}
              onChange={(value) => {
                setFormDataD({
                  ...formDataD,
                  securityDepositAmount: Number(value),
                });
              }}
              min={0}
              name="securityAmountDeposit"
              onKeyDown={handleNumericInput}
            />
          </div>
        </div>
        <h3 style={{ margin: "0px" }}>
          Rental Calculations<span>*</span>
        </h3>
        {Object.keys(formDataD?.rentCalculations).map((key) => {
          const typedKey = key as RentCalculationKeys;
          const rentalPlan = formDataD?.rentCalculations[typedKey];

          return (
            <div key={typedKey}>
              <div className={style["day-inp-container"]}>
                <div className={style["wrap-disable"]}>
                  <div className={style["title"]}> {typedKey}</div>
                  <Switch
                    checked={!rentalPlan.disabled}
                    onChange={(checked) => {
                      setFormDataD((prev) => {
                        const updatedRentCalculations = {
                          ...prev.rentCalculations,
                          [typedKey]: {
                            ...rentalPlan,
                            disabled: !checked,
                            price: checked
                              ? Math.max(rentalPlan.price ?? 1, 1)
                              : 0,
                            kmLimit: checked
                              ? Math.max(rentalPlan.kmLimit ?? 1, 1)
                              : 0,
                          },
                        };

                        // Check if all rental plans are disabled
                        const allDisabled = (
                          Object.keys(updatedRentCalculations) as Array<
                            keyof typeof updatedRentCalculations
                          >
                        ).every((key) => updatedRentCalculations[key].disabled);

                        // If all plans are disabled, disable `weekendPrice` (if it exists)
                        if (allDisabled) {
                          (
                            Object.keys(updatedRentCalculations) as Array<
                              keyof typeof updatedRentCalculations
                            >
                          ).forEach((key) => {
                            if (
                              "weekendPrice" in updatedRentCalculations[key]
                            ) {
                              updatedRentCalculations[key] = {
                                ...updatedRentCalculations[key],
                                weekendPrice: {
                                  ...(
                                    updatedRentCalculations[
                                      key
                                    ] as DaySpecificRentCalculation
                                  ).weekendPrice,
                                  disabled: true,
                                  price: 0,
                                  kmLimit: 0,
                                },
                              };
                            }
                          });
                        }

                        return {
                          ...prev,
                          rentCalculations: updatedRentCalculations,
                        };
                      });
                    }}
                  />
                </div>
                <div className={style["wrap-price"]}>
                  <div className={style["price-conatiner"]}>
                    <div className={style["title"]}> Price</div>
                    <InputNumber
                      value={rentalPlan.price}
                      min={0}
                      required
                      onChange={(value) => {
                        setFormDataD((prev) => ({
                          ...prev,
                          rentCalculations: {
                            ...prev.rentCalculations,
                            [typedKey]: {
                              ...rentalPlan,
                              price: rentalPlan.disabled
                                ? 0
                                : Math.max(Number(value ?? 1), 1),
                            },
                          },
                        }));
                      }}
                      onKeyDown={handleNumericInput}
                    />
                  </div>
                  <div className={style["price-conatiner"]}>
                    <div className={style["limit-title"]}> Km Limit</div>
                    <InputNumber
                      value={rentalPlan.kmLimit}
                      min={0}
                      required
                      onChange={(value) => {
                        setFormDataD((prev) => ({
                          ...prev,
                          rentCalculations: {
                            ...prev.rentCalculations,
                            [typedKey]: {
                              ...rentalPlan,
                              kmLimit: rentalPlan.disabled
                                ? 0
                                : Math.max(Number(value ?? 1), 1),
                            },
                          },
                        }));
                      }}
                      onKeyDown={handleNumericInput}
                    />
                  </div>
                </div>
                {"weekendPrice" in rentalPlan && rentalPlan.weekendPrice && (
                  <div className={style["day-inp-container"]}>
                    <div className={style["wrap-disable"]}>
                      <div className={style["title"]}> Weekend Price</div>
                      <Switch
                        checked={!rentalPlan.weekendPrice.disabled}
                        onChange={(checked) => {
                          setFormDataD((prev) => ({
                            ...prev,
                            rentCalculations: {
                              ...prev.rentCalculations,
                              [typedKey]: {
                                ...rentalPlan,
                                weekendPrice: {
                                  ...rentalPlan.weekendPrice,
                                  disabled: !checked,
                                  price: checked
                                    ? Math.max(
                                        rentalPlan.weekendPrice.price ?? 1,
                                        1
                                      )
                                    : 0,
                                  kmLimit: checked
                                    ? Math.max(
                                        rentalPlan.weekendPrice.kmLimit ?? 1,
                                        1
                                      )
                                    : 0,
                                },
                              },
                            },
                          }));
                        }}
                      />
                    </div>
                    <div className={style["wrap-price"]}>
                      <div className={style["price-conatiner"]}>
                        <div className={style["title"]}> Price</div>
                        <InputNumber
                          value={rentalPlan.weekendPrice?.price ?? 0}
                          min={rentalPlan.weekendPrice?.disabled ? 0 : 1}
                          required
                          onChange={(value) => {
                            let priceModify = 0;
                            if (
                              formDataD?.rentCalculations?.halfDay?.disabled &&
                              rentalPlan.weekendPrice?.disabled
                            ) {
                              priceModify = 0;
                            } else {
                              priceModify = Math.max(Number(value ?? 1), 1);
                            }
                            setFormDataD((prev) => ({
                              ...prev,
                              rentCalculations: {
                                ...prev.rentCalculations,
                                [typedKey]: {
                                  ...rentalPlan,
                                  weekendPrice: {
                                    ...rentalPlan.weekendPrice,
                                    price: priceModify,
                                  },
                                },
                              },
                            }));
                          }}
                          onKeyDown={handleNumericInput}
                        />
                      </div>
                      <div className={style["price-conatiner"]}>
                        <div className={style["limit-title"]}> Km Limit</div>
                        <InputNumber
                          value={rentalPlan.weekendPrice?.kmLimit ?? 0}
                          min={rentalPlan.weekendPrice?.disabled ? 0 : 1}
                          required
                          onChange={(value) => {
                            setFormDataD((prev) => ({
                              ...prev,
                              rentCalculations: {
                                ...prev.rentCalculations,
                                [typedKey]: {
                                  ...rentalPlan,
                                  weekendPrice: {
                                    ...rentalPlan.weekendPrice,
                                    kmLimit: rentalPlan.weekendPrice?.disabled
                                      ? 0
                                      : Math.max(Number(value ?? 1), 1),
                                  },
                                },
                              },
                            }));
                          }}
                          onKeyDown={handleNumericInput}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}

        <div className={btnStyle["wrap-submit-cancel"]}>
          <CommonButton color="green" onClick={() => onSave()}>
            Save
          </CommonButton>
          <CommonButton color="secondary" onClick={() => setMode("home")}>
            Cancel
          </CommonButton>
        </div>
      </div>
    </div>
  );
}

function PartnerBikes() {
  const [mode, setMode] = useState("home" as "edit" | "create" | "home");
  const [data, setData] = useState([] as Data[]);
  const [selectedData, setSelectedData] = useState({} as Data);
  const [originalData, setOriginalData] = useState<any[]>([]);

  const onEdit = (record: Data) => {
    setSelectedData(record);
    setMode("edit");
  };

  const onCreate = () => {
    setSelectedData(defaultData);
    setMode("create");
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _onDelete = async (record: Data) => {
    const Bike = await API.admin.DeleteBike(record._id as string);

    if (!API.validators.checkSuccessCode(Bike))
      message.error("Technical error");

    message.success("Deleted Successfully");
    getBikesDetails();
  };

  const columns: TableProps<Data>["columns"] = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Number",
      dataIndex: "number",
      key: "number",
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a onClick={() => onEdit(record)}>Edit</a>
          {/* <a onClick={() => _onDelete(record)}>Delete</a> */}
        </Space>
      ),
    },
  ];

  const getBikesDetails = async () => {
    const stationId = storage.getSelectedStation().id;
    if (!stationId) return;
    const getData = await API.partner.GetBikes({ stationId: stationId });

    if (!API.validators.checkSuccessCode(getData)) {
      return message.error("Technical error");
    }

    setData(getData.data?.data);
    setOriginalData(getData.data?.data);
  };

  useEffect(() => {
    getBikesDetails();
  }, [mode]);

  return (
    <div>
      {mode === "home" && (
        <div>
          <div className={style["warp-search-inp"]}>
            <SearchFeature
              originalData={originalData}
              setData={setData}
              keyData="name"
              placeholder="Search By Bike Name"
            />
            <CommonButton color="primary" onClick={() => onCreate()}>
              Add Bike
            </CommonButton>
          </div>

          <AntTable columns={columns} data={data} />
        </div>
      )}
      {mode === "create" && (
        <CreateEditBike mode="create" setMode={setMode} data={selectedData} />
      )}
      {mode === "edit" && (
        <CreateEditBike mode="edit" setMode={setMode} data={selectedData} />
      )}
    </div>
  );
}

export default PartnerBikes;
